import { Container, styled } from "@mui/material";

const FEATURED_WEBINARS_PREFIX = "FeaturedWebinars";

export const featuredWebinarsClasses = {
  root: `${FEATURED_WEBINARS_PREFIX}-root`,
};

export const StyledFeaturedWebinars = styled(Container)(({ theme }) => ({
  [`&.${featuredWebinarsClasses.root}`]: {},
}));

